import {
  FORTRESS_BENCHMARK_DASHBOARD,
  FORTRESS_CREATE_REPORTS,
} from 'src/app/reporting/services/ReportingServiceConstants';
import { Policy } from './Policy';
import { PolicyElement } from './PolicyElement';

export class BenchmarkPolicy extends Policy {
  override readonly keyStart = new RegExp(
    `^${FORTRESS_CREATE_REPORTS}\\.${FORTRESS_BENCHMARK_DASHBOARD}\\.`,
  );

  etf = new PolicyElement('ETF');
  tables = new PolicyElement('TABLES');

  constructor() {
    super();
    this.policyElements.push(this.etf, this.tables);
  }
}
